import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {IStringAnyMap} from "lib-boox";
import {ResetPasswordComponent} from "../../component/reset-password/reset-password.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-reset-password-view',
  standalone: true,
  imports: [
    ResetPasswordComponent, RouterModule, NgIf
  ],
  templateUrl: './reset-password-view.component.html',
  styleUrl: './reset-password-view.component.scss'
})
export class ResetPasswordViewComponent implements OnInit{
  public email: string = '';
  public code: string = '';
  public type: string = 'password';

  constructor(
    private route: ActivatedRoute,
    private router : Router,
  ){}

  ngOnInit(): void {
    // Read query parameters from the URL
    this.email = this.route.snapshot.queryParamMap.get('email') || '';
    this.code = this.route.snapshot.queryParamMap.get('code') || '';
    this.type = this.route.snapshot.queryParamMap.get('type') || 'password';
  }

  public success () {
    this.router.navigate(['/']);
  }

  public fail (error : IStringAnyMap) {

  }
}
